<ws-modal-wrapper [headerLabel]="title"
                  [hideFooter]="true"
                  (cancel)="bsModalRef.hide()">
    <div style="margin-top: 20px;">
        <input id="engagementSearch"
               type="text"
               class="form-control"
               [(ngModel)]="searchTerm"
               style="display: inline-block; width: 90%; margin-bottom: 15px;"
               (keyup.enter)="search()">
        <button class="ace-btn has-icon btn-primary" [disabled]="!searchTerm">
            <i class="fa fa-search" (click)="search()"></i>
        </button>
    </div>
    @if (isLoading) {
        <div class="text-center" style="margin-top: 50px;">
            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
        </div>
    }
    @if (!isLoading && !engagementResults.length && initialSearch) {
        <div>
            <em class="lead">No results</em>
        </div>
    }
    @if (!isLoading && engagementResults.length) {
        <div class="fixed-table-container hidden-head">
            <div class="header-background"></div>
            <div class="fixed-table-container-inner">
                <table class="table table-condensed table-hover">
                    <thead>
                        <tr>
                            <th>
                                <div class="th-inner">
                                    Engagement #
                                </div>
                            </th>
                            <th>
                                <div class="th-inner">
                                    Client Name
                                </div>
                            </th>
                            <th>
                                <div class="th-inner">
                                    Description
                                </div>
                            </th>
                        </tr>
                        <tr class="hidden-header">
                            <th>
                                <div class="th-inner">
                                    Engagement #
                                </div>
                            </th>
                            <th>
                                <div class="th-inner">
                                    Client Name
                                </div>
                            </th>
                            <th>
                                <div class="th-inner">
                                    Description
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll; height: 300px;">
                        @for (engagement of engagementResults; track engagement) {
                            <tr style="cursor: pointer;" (click)="selectEngagement(engagement)">
                                <td>{{ engagement.engagementID }}</td>
                                <td style="max-width: 400px;">{{ engagement.clientName }}</td>
                                <td>{{ engagement.engagementDesc }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
</ws-modal-wrapper>
